import { BaseApi } from "@/api/base";
import type { QueryParams } from "@/api/types";
import type { Response } from "@/api/client";
import type { ListResponseDto } from "@/api/dto/list-response.dto";
import type { LogRecordDto } from "@/api/service/dto/log-record.dto";

export class ServiceApi extends BaseApi {
  fetchLogs(options: QueryParams = {}): Promise<Response<ListResponseDto<LogRecordDto>>> {
    return this.client.get("logs", options);
  }
}
